import actions from './actions';
import mutations from './mutations';
import initialState from './state';
import getters from './getters';

export default {
  namespaced: true,
  state: { ...initialState },
  getters,
  actions,
  mutations,
};
